import React, { useState } from "react"
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ArrowDropDownCircle from "@material-ui/icons/ArrowDropDownCircle"
import TextField from '@material-ui/core/TextField'
import SaveIcon from '@material-ui/icons/Save'
import {useToReview, setUpdateProposals} from '../redux/plan'
import {useRoles, useName, useToken} from '../redux/auth'
import { setSelectedModule } from '../redux/navigation'
import { EditorConvertToHTML } from './myeditor'
import { getSOPforReplacement, saveSOP, getProposals } from '../modules/db'
import { setOpenDialog, setChanges } from '../redux/navigation'
import Auto from '../components/autotags'
import { theme } from "../theme";

const AdminApprovalEditor =  () => {
    const {colors} = theme
    const token = useToken()
    const sopData = useToReview()
    const roles = useRoles()
    const name = useName()
    const [sopState, setSopState] = useState(sopData)
    const [useCriteria, setCriteria] = useState(sopData.criteriaandinstructions || '<p></p>')
    const [useMonitoring, setMonitoring] = useState(sopData.monitoring || '<p></p>')
    const [useResponsibilities, setResponsibilities] = useState(sopData.responsibilities || '<p></p>')
    const [usePurpose, setPurpose] = useState(sopData.purposeandintroduction || '<p></p>')
    const [useCorrective, setCorrective] = useState(sopData.correctiveactions || '<p></p>')
    const [useVerification, setVerification] = useState(sopData.verificationandrecordkeeping || '<p></p>')
    

    const upTags = (tag, val) => {
        console.log(val)
        setChanges(true)
        let res = {...sopState}
        if(!res.hasOwnProperty('humantags')){
            res['humantags']={}
        } else{
            res.humantags[tag]=val 
        }
        setSopState(res)
        localStorage.setItem('localSOP', JSON.stringify(res))
    }
    const handleRejectClick = (sop) => {
        setOpenDialog(
            {
                open:true, 
                txt:'You are about to REJECT this, are you sure?',
                neg : handleDialogNeg,
                pos : handleDialogPosRej
            }
        )
    }

    const handleReplacement = async (sop) => {
        const val = validate(sop)
        console.log(val)
        if(val.empty.length===0){
            setOpenDialog(
                {
                  open:true, 
                  txt:'You are about to APPROVE this REPLACING the old one, are you sure?',
                  neg : handleDialogNeg,
                  pos : handleDialogPosRep
                }
            )
        } else {
            alert('You need to fill the following fields:   \n' + val.empty.join(', \n'))
        } 
    }
    
    const handleApproveAsNew = (sop) => {
        const val = validate(sop)
        console.log(val)
        if(val.empty.length===0){
            setOpenDialog(
                {
                  open:true, 
                  txt:'You are about to APPROVE this as NEW, are you sure?',
                  neg : handleDialogNeg,
                  pos : handleDialogPosNew
                }
            )
        } else {
            alert('You need to fill the following fields:   \n' + val.empty.join(', \n')) 
        }
    }
    const handleTagsChange = (event) => {
        let res = {...sopState}
        if(!res.humantags){
            res['humantags']={}
        }
        res.humantags[event.target.id]=event.target.value.split(',')    
        setSopState(res)
    }
        
    const handleFormChange = (event) => {
        let res = {...sopState}
        res[event.target.id]=event.target.value
        setSopState(res)
      }

      const handleDialogNeg = () => {
        setOpenDialog({
          open:false, 
          txt:'',
          neg:null,
          pos:null
        })
      }

      const handleDialogPosRep = async() => {
        setOpenDialog({
          open:false, 
          txt:'',
          neg:null,
          pos:null
        })
        let Rep = {...sopState}
        Rep['type']='approved'
        Rep['criteriaandinstructions']=useCriteria
        Rep['monitoring']=useMonitoring
        Rep['responsibilities']=useResponsibilities
        Rep['purposeandintroduction']=usePurpose
        Rep['correctiveactions']=useCorrective
        Rep['verificationandrecordkeeping']=useVerification
        Rep['writer']=name
        if( sopState.hasOwnProperty('basedonsop') & sopState._id!==sopState.basedonsop ){
            let base = await getSOPforReplacement(sopState.basedonsop)
            base['type']='archivedSOP'
            saveSOP(base, token)
        }
        saveSOP(Rep, token)
        getProposals()
        setSelectedModule('Editor') 
      }

      const handleDialogPosRej = () => {
        console.log(sopState)
        var Rej = {...sopState}
        Rej['type']='archivedSOP'
        getProposals()
        saveSOP(Rej, token)
        setOpenDialog({
            open:false, 
            txt:'',
            neg:null,
            pos:null
          })
      }

      const handleDialogPosNew = () => {
        setOpenDialog({
          open:false, 
          txt:'',
          neg:null,
          pos:null
        })
        var nu = {...sopState}
        nu['basedonsop']=sopState._id
        roles.includes('admin') ? nu['type']='approved':nu['type']='proposal'
        nu['criteriaandinstructions']=useCriteria
        nu['monitoring']=useMonitoring
        nu['responsibilities']=useResponsibilities
        nu['purposeandintroduction']=usePurpose
        nu['correctiveactions']=useCorrective
        nu['verificationandrecordkeeping']=useVerification
        nu['writer']=name
        delete nu['_rev']
        delete nu['_id']
        saveSOP(nu, token)
        getProposals(token)
        setSelectedModule('Organize')
      }
    
      
      const validate = (sop) => {
        console.log(sop)
        const tags = ['AR','LOC','DOC','PR','ING', 'PRS', 'EQU','PAC']
        let res = {empty:[], filled:[], tags:false}
        tags.forEach(x=>{
            if(sop.humantags.hasOwnProperty(x)){
                (sop.humantags[x].length > 0 && sop.humantags[x][0] !== '') ? res.filled.push('tag') : res.empty.push('All TAGS needs to be filled')
            } else {
                res.tags = true
            }
        })
         if (sopData.doctype === 'Doc'){
            sop.hasOwnProperty('title') ?
                sop.title!=='' ? res.filled.push('Title'):res.empty.push('Title')
                :res.empty.push('Title')
            sop.hasOwnProperty('text') ?
                sop.title!=='' ? res.filled.push('Text'):res.empty.push('Text')
                :res.empty.push('Text')
            
            return res
        }  else {
            sop.hasOwnProperty('monitoring') ?
                sop.monitoring!=='' ? res.filled.push('Monitoring'): res.empty.push('Monitoring')
                : res.empty.push('Monitoring')
            sop.hasOwnProperty('criteriaandinstructions') ?
                sop.criteriaandinstructions!=='' ? res.filled.push('Criteria and instructions'): res.empty.push('Criteria and instructions')
                : res.empty.push('Criteria and instructions')
            sop.hasOwnProperty('responsibilities') ?
                sop.responsibilities!=='' ? res.filled.push('Responsibilities'): res.empty.push('Responsibilities')
                : res.empty.push('Responsibilities')
            sop.hasOwnProperty('purposeandintroduction') ?
                sop.purposeandintroduction!=='' ? res.filled.push('Purpose and introduction'): res.empty.push('Purpose and introduction')
                : res.empty.push('Purpose and introduction')
            sop.hasOwnProperty('correctiveactions') ?
                sop.correctiveactions!=='' ? res.filled.push('Corrective actions'): res.empty.push('Corrective actions')
                : res.empty.push('Corrective actions')
            sop.hasOwnProperty('verificationandrecordkeeping') ?
                sop.verificationandrecordkeeping!=='' ? res.filled.push('Verification and record keeping'): res.empty.push('Verification and record keeping')
                : res.empty.push('Verification and record keeping')
            sop.hasOwnProperty('title') ?
                sop.title!=='' ? res.filled.push('Title'):res.empty.push('Title')
                :res.empty.push('Title')
            
            return res
        }

    }

    return (
        <Paper elevation={3} style={{paddingTop:100, paddingBottom:50}} >
            <p>Writer: {sopState.writer}</p>
            <form noValidate autoComplete="off">
                <div>
                    <TextField id="title" label="Title" value={sopState.title} 
                    onChange={(e) => handleFormChange(e)}  
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h3>Purpose and Introduction</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                            <EditorConvertToHTML html={usePurpose} update={setPurpose}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h3>Criteria and Instructions</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                            
                            <EditorConvertToHTML html={useCriteria} update={setCriteria}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div>
                    <TextField id="frequency" label="Frequency" value={sopState.frequency} 
                        onChange={(e) => handleFormChange(e)} 
                        style={{width:'80%', marginBottom:20}} multiline rowsMax={4} 
                    />
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h3>Responsibilities</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML html={useResponsibilities} update={setResponsibilities} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h3>Monitoring</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML html={useMonitoring} update={setMonitoring} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h3>Corrective actions</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                            <EditorConvertToHTML html={useCorrective} update={setCorrective}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                    <ExpansionPanel>
                        <ExpansionPanelSummary
                            expandIcon={<ArrowDropDownCircle />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <h3>Verification and record keeping</h3>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                            <EditorConvertToHTML html={useVerification} update={setVerification}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
                <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="AR" 
                                value={sopState.humantags ? sopState.humantags.AR : ''}
                                title={"Audit Requirements"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'AR'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="LOC" 
                                value={sopState.humantags ? sopState.humantags.LOC : ''}
                                title={"Locations"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'LOC'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="DOC" 
                                value={sopState.humantags ? sopState.humantags.DOC : ''}
                                title={"Document type"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'DOC'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="PR" 
                                value={sopState.humantags ? sopState.humantags.PR : ''}
                                title={"Process"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'PR'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="ING" 
                                value={sopState.humantags ? sopState.humantags.ING : ''}
                                title={"Ingredients"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'ING'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="PRS" 
                                value={sopState.humantags ? sopState.humantags.PRS : ''}
                                title={"Process Step"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'PRS'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="EQU" 
                                value={sopState.humantags ? sopState.humantags.EQU : ''}
                                title={"Equipment"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'EQU'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="PAC" 
                                value={sopState.humantags ? sopState.humantags.PAC : ''}
                                title={"Packaging material type"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'PAC'}
                             />
                        </div>
            </form>
            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { handleApproveAsNew(sopState) }}
                style={{ 
                backgroundColor: colors.secondary,
                color:'white',
                bottom: -20
                }}
            >
                Approve as new
            </Button>

            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { handleReplacement(sopState ) }}
                style={{ 
                backgroundColor: colors.secondary,
                color:'white',
                bottom: -20
                }}
            >
                Approve replacing
            </Button>


            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { handleRejectClick(sopState) }}
                style={{ 
                backgroundColor: colors.secondary,
                color:'white',
                bottom: -20
                }}
            >
                Reject and delete
            </Button>
        </Paper>
    )
}
export default AdminApprovalEditor

